import ParticleCard from '@qc/particle/lib/components/card'
import ParticleForm from '@qc/particle/lib/components/form'
import { Row, Col } from '@qc/particle/lib/components/grid';

import styled from 'styled-components';

export const QuantcastLogo = styled.div`
  background-position: center;
  background-size: contain;
  background-image: url("https://static.quantcast.com/images/quantcast-logo-black.svg");
  background-repeat: no-repeat;
  height: 26px;
  width: 148px;
  margin-bottom: 30px;
`;
export const FormControl = styled(ParticleForm.Item)`
  .progress-spinner__root {
    width: 20px;
    height: 20px;
  }
  .particle-btn {
    width: 100%;
  }
  ul {
    padding: 5px;
  }
`;

export const MainContent = styled(Row)`
  margin-top: 100px;
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const Card = styled(ParticleCard)`
  background-color: #fff;
  width: 400px;
  padding: 10px 42px 20px;
  
  .particle-card-body {
    padding: 0px;
  }

  @media only screen and (max-height: 750px) {
    margin-top: 10px;
  }

  .simple-card__content {
    padding: 30px 20px 30px 20px;
  }

  .particle-form-item-label {
    padding-bottom: 4px;
  }

  .particle-form-item-label > label {
    color: var(--gray-8);
    font-weight: 600;
  }
  
  .particle-alert {
    margin-bottom: 10px;
  }
`;

export const CardLarge = styled(Card)`
  width: 600px;

  :has(#signupSuccessCard) {
    width: 800px !important;
    padding-bottom: 0px !important;

    .particle-result-icon {
      display: none !important;
    }

    .particle-result-info {
      padding-top: 10px !important;
      padding-bottom: 10px !important;
    }

    .particle-result-title {
      margin-bottom: 20px !important;
    }
  }
`;

export const H3 = styled.h3`
    margin-top: 10px;
    margin-bottom: 22px;
    font-weight: 600;
    color: #5e5e5e;
    font-size: 20px;
`;

export const CheckMark = styled.span`
  color: var(--green-6);
  height: 8p;
  margin-right: 8px;
  width: 8px;
`;

export const ChangesSavedLabel = styled.div`
  align-items: center;
  color: var(--green-6);
  display: flex;
  margin-right: 10px;
  font-size: 14px;
`;

export const ErrorMessageApi = styled.div`
  width: 400px;
  margin-top: 10px;
  p{color: var(--red-6)};
`;

export const FooterHolder = styled.footer`
    background: none repeat scroll 0 0 transparent;
    text-align: center;
    width: 100%;
    height: 20px;
    padding-top: 25px;
  `;

export const Footer = styled.div`
    margin: auto;
    a {
      color: var(--gray-13);
      font-size: 12px;
      font-weight: unset;
    }
  `;

export const FooterLink = styled.span`
    margin: 1em;    
  `;
